import { System } from 'common/systems/domain/resources/system.resource';

/**
 * Hand-rolled, normalized "entity"-style state for the `systems` capability
 * (no ngrx entity helper library, see proposal.md/design.md of
 * `systems-capability`). `entities` allows O(1) lookup of a `System` by
 * `id`, while `ids` preserves insertion order for iteration (`selectAll`).
 */
export interface SystemsState {
    readonly ids: ReadonlyArray<string>;
    readonly entities: Readonly<Record<string, System>>;
    readonly loading: boolean;
    readonly error: unknown | null;
}

export const INITIAL_SYSTEMS_STATE: SystemsState = {
    ids: [],
    entities: {},
    loading: false,
    error: null,
};
